import type { ApplicationFeeResponse } from '@acme/api';
import { Separator, renderFieldIfText } from '@acme/foundation';

export const Commission = ({
  fee,
  separateCommissions,
}: {
  fee: ApplicationFeeResponse | null;
  separateCommissions?: boolean;
}) => {
  if (!fee) return null;

  return (
    <>
      <Separator className="-mx-6" />
      <div className="flex flex-col gap-4">
        <div className="text-xl font-semibold text-gray-900">Комиссии</div>

        <div className="grid grid-cols-3 gap-6">
          {separateCommissions ? (
            <>
              {renderFieldIfText(
                'Комиссия УО, руб',
                fee.fee != null ? String(fee.fee) : null
              )}
              {renderFieldIfText(
                'Комиссия агента, руб',
                fee.agentFee != null ? String(fee.agentFee) : null
              )}
            </>
          ) : (
            <>
              {renderFieldIfText(
                'Комиссия, руб',
                fee.fee != null ? String(fee.fee) : null
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};
